export enum ActionListingType {
  StakeholderDetail = 'stakeholderdetail',
  StakeholderAll = 'stakeholderall',
  LogEdit = 'logedit',
}
